export default [
  {
    "x": 3.08131764,
    "y": 29.3117736,
    "angle": 1.7517242820509347,
    "lengthA": 26.347163824896835,
    "lengthB": 8.265901854603468
  },
  {
    "x": 9.60041711,
    "y": 1.68274622,
    "angle": 2.6943911069806434,
    "lengthA": 1.9682504538392485,
    "lengthB": 1.9682504547041355
  },
  {
    "x": 31.9317572,
    "y": 9.41775253,
    "angle": 3.141592653589793,
    "lengthA": 5.8170897,
    "lengthB": 16.543883200000003
  },
  {
    "x": 59.4216697,
    "y": 0.903243881,
    "angle": -2.7821355862008565,
    "lengthA": 2.215968068891448,
    "lengthB": 2.2159679749308796
  },
  {
    "x": 69.5831838,
    "y": 48.8282026,
    "angle": -1.7002352109676788,
    "lengthA": 18.070096198438787,
    "lengthB": 35.771841206180426
  },
  {
    "x": 55.7602701,
    "y": 183.624367,
    "angle": -1.1123643203749443,
    "lengthA": 35.38311049214148,
    "lengthB": 10.770918422733137
  },
  {
    "x": 32.6536741,
    "y": 194.874221,
    "angle": -0.20426770133378647,
    "lengthA": 8.756202963837294,
    "lengthB": 12.327246957985777
  },
  {
    "x": 6.1837988,
    "y": 142.37581,
    "angle": 1.4538480396701916,
    "lengthA": 51.42283794354748,
    "lengthB": 51.42283804893188
  }
]